// language=GraphQL
export const ALL_LINKS_QUERY = `query Query($withPage: Boolean = false, $withPageSeoSettings: Boolean = false, $withPageSeoSettingsOgImage: Boolean = false, $withPageContentBlockAssignments: Boolean = false, $withPageContentBlockAssignmentsBlock: Boolean = false, $withTravel: Boolean = false, $withTravelAvailabilityStatus: Boolean = false, $withTravelAvailabilityStatusTenantSettings: Boolean = false, $withTravelTravelConsultant: Boolean = false, $withTravelTravelConsultantImage: Boolean = false, $withTravelLabel: Boolean = false, $withTravelSeoSettings: Boolean = false, $withTravelSeoSettingsOgImage: Boolean = false, $withTravelTenantSettings: Boolean = false, $withTravelTenantSettingsTenant: Boolean = false, $withTravelTenantSettingsTravelTypes: Boolean = false, $withTravelHighlights: Boolean = false, $withTravelPartners: Boolean = false, $withTravelPartnersLogo: Boolean = false, $withTravelPartnersGtcPdf: Boolean = false, $withTravelTravelGuides: Boolean = false, $withTravelTravelGuidesImage: Boolean = false, $withTravelTeams: Boolean = false, $withTravelTeamsMembers: Boolean = false, $withTravelAccommodationAssignments: Boolean = false, $withTravelAccommodationAssignmentsAccommodation: Boolean = false, $withTravelAccommodationAssignmentsRoomTypes: Boolean = false, $withTravelAccommodations: Boolean = false, $withTravelAccommodationsRoomTypes: Boolean = false, $withTravelAccommodationsAvailableAddons: Boolean = false, $withTravelAccommodationsGallery: Boolean = false, $withTravelDestinations: Boolean = false, $withTravelTestimonials: Boolean = false, $withTravelTestimonialsContentBlock: Boolean = false, $withTravelMainImage: Boolean = false, $withTravelMainVideo: Boolean = false, $withTravelGallery: Boolean = false, $withTravelGalleryImages: Boolean = false, $withTravelTravelPdf: Boolean = false, $withTravelTravelExtensions: Boolean = false, $withTravelTravelExtensionsHighlights: Boolean = false, $withTravelTravelExtensionsImage: Boolean = false, $withTravelItinerary: Boolean = false, $withTravelItineraryItems: Boolean = false, $withTravelPricing: Boolean = false, $withTravelPricingAgeGroupSettings: Boolean = false, $withTravelPricingCustomDataConfig: Boolean = false, $withTravelPricingTravels: Boolean = false, $withTravelPricingWebhookConfig: Boolean = false, $withTravelPricingBranding: Boolean = false, $withTravelPricingBargainSettings: Boolean = false, $withTravelPricingEsimSettings: Boolean = false, $withTravelPricingPassportConfig: Boolean = false, $withTravelPricingTourOperator: Boolean = false, $withTravelPricingCurrencyOverride: Boolean = false, $withTravelFaqs: Boolean = false) {
  links: links {
    id
    label
    targetBlank
    type
    url
    page @include(if: $withPage) {
      id
      name
      onlineStatus
      seoSettings @include(if: $withPageSeoSettings) {
        id
        urlSlug
        metaTitle
        metaDescription
        ogTitle
        ogDescription
        ogImage @include(if: $withPageSeoSettingsOgImage) {
          id
          assetId
          publicId
          url
          resourceType
          format
          width
          height
          caption
          title
          description
        }
      }
      contentBlockAssignments @include(if: $withPageContentBlockAssignments) {
        id
        type
        block @include(if: $withPageContentBlockAssignmentsBlock) {
          __typename
          ... on CmsTextBlock {
            id
            text

          }
          ... on CmsTextWithImageBlock {
            id
            title
            subtitle
            text
            imagePosition
            imageFixedAspectRatio

          }
          ... on CmsPageHeaderBlock {
            id
            title
            text

          }
          ... on CmsWysiwygBlock {
            id
            html

          }
          ... on CmsHeadingBlock {
            id
            importance
            heading
            addon
            decoration

          }
          ... on CmsTextWithIconBlock {
            id
            title
            text
            imagePosition

          }
          ... on CmsAccordionBlock {
            id

          }
          ... on CmsGridBlock {
            id

          }
          ... on CmsImageBlock {
            id
            text
            fluid

          }
          ... on CmsEmployeesBlock {
            id

          }
          ... on CmsContactBannerBlock {
            id
            email
            phonePrefix
            phone
            phone2Prefix
            phone2

          }
          ... on CmsNewsletterRegisterBlock {
            id
            fluid

          }
          ... on CmsIssuuCatalogBlock {
            id
            publicationCode
            accountName

          }
          ... on CmsFormBlock {
            id
            formName

          }
          ... on CmsHeaderSliderBlock {
            id

          }
          ... on CmsBestsellerSliderBlock {
            id
            fluid

          }
          ... on CmsFilterLeadBlock {
            id
            layout

          }
          ... on CmsTravelTypesBlock {
            id
            layout

          }
          ... on CmsPrefilteredTravelsBlock {
            id
            maxResults

          }
          ... on CmsDividerBlock {
            id
            fluid

          }
          ... on CmsTravelSelectionBlock {
            id

          }
          ... on CmsIframeBlock {
            id
            url
            minHeight

          }
          ... on CmsSliderBlock {
            id
            fluid
            size
            showDots
            showArrows
            showLightbox
            autoplay

          }
          ... on CmsDestinationsBlock {
            id

          }
          ... on CmsTravelGuidesBlock {
            id

          }
          ... on CmsBusfinderBlock {
            id
            title

          }
          ... on CmsBackgroundBlock {
            id
            backgroundVariant

          }
          ... on CmsButtonBlock {
            id
            variant
            size
            position

          }
        }
      }
    }
    travel @include(if: $withTravel) {
      id
      name
      isBestseller
      startDate
      endDate
      availabilityStatus @include(if: $withTravelAvailabilityStatus) {
        id
        label
        status
        isDefaultStatus
        isDefaultWaitlistFallback
        tenantSettings @include(if: $withTravelAvailabilityStatusTenantSettings) {
          id
          label
          info
          switchToStatusInfo
          submitButtonLabel
        }
      }
      executionStatus
      travelConsultant @include(if: $withTravelTravelConsultant) {
        id
        firstName
        lastName
        jobTitle
        description
        email
        image @include(if: $withTravelTravelConsultantImage) {
          id
          assetId
          publicId
          url
          resourceType
          format
          width
          height
          caption
          title
          description
        }
        phone
      }
      label @include(if: $withTravelLabel) {
        id
        label
      }
      title
      description
      introVideoUrl
      includedServices
      excludedServices
      pricingTable
      priceCalculationInfo
      seoSettings @include(if: $withTravelSeoSettings) {
        id
        urlSlug
        metaTitle
        metaDescription
        ogTitle
        ogDescription
        ogImage @include(if: $withTravelSeoSettingsOgImage) {
          id
          assetId
          publicId
          url
          resourceType
          format
          width
          height
          caption
          title
          description
        }
      }
      tenantSettings @include(if: $withTravelTenantSettings) {
        id
        tenant @include(if: $withTravelTenantSettingsTenant) {
          id
          name
          slug
          domain
          externalReference
        }
        onlineStatus
        redirectToBooking
        useTiming
        startDate
        endDate
        travelTypes @include(if: $withTravelTenantSettingsTravelTypes) {
          id
          name
          description
        }
      }
      highlights @include(if: $withTravelHighlights) {
        id
        text
      }
      partners @include(if: $withTravelPartners) {
        id
        name
        url
        logo @include(if: $withTravelPartnersLogo) {
          id
          assetId
          publicId
          url
          resourceType
          format
          width
          height
          caption
          title
          description
        }
        logoWidth
        gtcPdf @include(if: $withTravelPartnersGtcPdf) {
          id
          assetId
          publicId
          url
          resourceType
          format
          width
          height
          caption
          title
          description
        }
      }
      travelGuides @include(if: $withTravelTravelGuides) {
        id
        firstName
        lastName
        description
        image @include(if: $withTravelTravelGuidesImage) {
          id
          assetId
          publicId
          url
          resourceType
          format
          width
          height
          caption
          title
          description
        }
      }
      teams @include(if: $withTravelTeams) {
        id
        name
        members @include(if: $withTravelTeamsMembers) {
          id
          firstName
          lastName
          description
        }
      }
      accommodationAssignments @include(if: $withTravelAccommodationAssignments) {
        id
        accommodation @include(if: $withTravelAccommodationAssignmentsAccommodation) {
          id
          label
          name
          stars
          description
        }
        roomTypes @include(if: $withTravelAccommodationAssignmentsRoomTypes) {
          id
          name
          description
        }
        useCustomRoomTypeSelection
        displayDetails
      }
      accommodations @include(if: $withTravelAccommodations) {
        id
        label
        name
        stars
        description
        roomTypes @include(if: $withTravelAccommodationsRoomTypes) {
          id
          name
          description
        }
        availableAddons @include(if: $withTravelAccommodationsAvailableAddons) {
          id
          name
          description
        }
        gallery @include(if: $withTravelAccommodationsGallery) {
          id
        }
      }
      destinations @include(if: $withTravelDestinations) {
        id
        name
        entryRequirements
        medicalInformation
        language
        timeShift
        climate
        currency
      }
      testimonials @include(if: $withTravelTestimonials) {
        id
        contentBlock @include(if: $withTravelTestimonialsContentBlock) {
          id
          title
          text
          imagePosition
        }
      }
      mainImage @include(if: $withTravelMainImage) {
        id
        assetId
        publicId
        url
        resourceType
        format
        width
        height
        caption
        title
        description
      }
      mainVideo @include(if: $withTravelMainVideo) {
        id
        assetId
        publicId
        url
        resourceType
        format
        width
        height
        caption
        title
        description
      }
      gallery @include(if: $withTravelGallery) {
        id
        images @include(if: $withTravelGalleryImages) {
          id
          assetId
          publicId
          url
          resourceType
          format
          width
          height
          caption
          title
          description
        }
      }
      travelPdf @include(if: $withTravelTravelPdf) {
        id
        assetId
        publicId
        url
        resourceType
        format
        width
        height
        caption
        title
        description
      }
      travelExtensions @include(if: $withTravelTravelExtensions) {
        id
        duration
        name
        description
        highlights @include(if: $withTravelTravelExtensionsHighlights) {
          id
          text
        }
        image @include(if: $withTravelTravelExtensionsImage) {
          id
          assetId
          publicId
          url
          resourceType
          format
          width
          height
          caption
          title
          description
        }
      }
      programType
      itinerary @include(if: $withTravelItinerary) {
        id
        items @include(if: $withTravelItineraryItems) {
          id
          duration
          title
          text
        }
      }
      programText
      pricing @include(if: $withTravelPricing) {
        id
        ageGroupSettings @include(if: $withTravelPricingAgeGroupSettings) {
          id
          freeUntilAge
        }
        isTravelDocumentationAvailable
        customDataConfig @include(if: $withTravelPricingCustomDataConfig) {
          id
          useTravellerForm
          useBookingForm
        }
        travels @include(if: $withTravelPricingTravels) {
          id
          catalogCode
          travelCode
          destination
          name
          transportType
          transportTypeLabel
          importDateTime
          importStatus
          suppressBusBoardingSelection
        }
        webhookConfig @include(if: $withTravelPricingWebhookConfig) {
          id
          enabled
          url
        }
        branding @include(if: $withTravelPricingBranding) {
          id
          logoWidth
        }
        bargainSettings @include(if: $withTravelPricingBargainSettings) {
          id
          active
          untilDaysBeforeStart
        }
        esimSettings @include(if: $withTravelPricingEsimSettings) {
          id
          enabled
        }
        passportConfig @include(if: $withTravelPricingPassportConfig) {
          id
          passportOnly
        }
        tourOperator @include(if: $withTravelPricingTourOperator) {
          id
          name
          url
          logoWidth
        }
        currencyOverride @include(if: $withTravelPricingCurrencyOverride) {
          id
          enabled
          exchangeRate
        }
      }
      minPrice
      minPriceManualOverride
      currency
      faqs @include(if: $withTravelFaqs) {
        id
        question
        answer
      }
    }
  }
}`

// language=GraphQL
export const SINGLE_LINK_QUERY = `query Query($id: ID!, $withPage: Boolean = false, $withPageSeoSettings: Boolean = false, $withPageSeoSettingsOgImage: Boolean = false, $withPageContentBlockAssignments: Boolean = false, $withPageContentBlockAssignmentsBlock: Boolean = false, $withTravel: Boolean = false, $withTravelAvailabilityStatus: Boolean = false, $withTravelAvailabilityStatusTenantSettings: Boolean = false, $withTravelTravelConsultant: Boolean = false, $withTravelTravelConsultantImage: Boolean = false, $withTravelLabel: Boolean = false, $withTravelSeoSettings: Boolean = false, $withTravelSeoSettingsOgImage: Boolean = false, $withTravelTenantSettings: Boolean = false, $withTravelTenantSettingsTenant: Boolean = false, $withTravelTenantSettingsTravelTypes: Boolean = false, $withTravelHighlights: Boolean = false, $withTravelPartners: Boolean = false, $withTravelPartnersLogo: Boolean = false, $withTravelPartnersGtcPdf: Boolean = false, $withTravelTravelGuides: Boolean = false, $withTravelTravelGuidesImage: Boolean = false, $withTravelTeams: Boolean = false, $withTravelTeamsMembers: Boolean = false, $withTravelAccommodationAssignments: Boolean = false, $withTravelAccommodationAssignmentsAccommodation: Boolean = false, $withTravelAccommodationAssignmentsRoomTypes: Boolean = false, $withTravelAccommodations: Boolean = false, $withTravelAccommodationsRoomTypes: Boolean = false, $withTravelAccommodationsAvailableAddons: Boolean = false, $withTravelAccommodationsGallery: Boolean = false, $withTravelDestinations: Boolean = false, $withTravelTestimonials: Boolean = false, $withTravelTestimonialsContentBlock: Boolean = false, $withTravelMainImage: Boolean = false, $withTravelMainVideo: Boolean = false, $withTravelGallery: Boolean = false, $withTravelGalleryImages: Boolean = false, $withTravelTravelPdf: Boolean = false, $withTravelTravelExtensions: Boolean = false, $withTravelTravelExtensionsHighlights: Boolean = false, $withTravelTravelExtensionsImage: Boolean = false, $withTravelItinerary: Boolean = false, $withTravelItineraryItems: Boolean = false, $withTravelPricing: Boolean = false, $withTravelPricingAgeGroupSettings: Boolean = false, $withTravelPricingCustomDataConfig: Boolean = false, $withTravelPricingTravels: Boolean = false, $withTravelPricingWebhookConfig: Boolean = false, $withTravelPricingBranding: Boolean = false, $withTravelPricingBargainSettings: Boolean = false, $withTravelPricingEsimSettings: Boolean = false, $withTravelPricingPassportConfig: Boolean = false, $withTravelPricingTourOperator: Boolean = false, $withTravelPricingCurrencyOverride: Boolean = false, $withTravelFaqs: Boolean = false) {
  link: link(id: $id) {
    id
    label
    targetBlank
    type
    url
    page @include(if: $withPage) {
      id
      name
      onlineStatus
      seoSettings @include(if: $withPageSeoSettings) {
        id
        urlSlug
        metaTitle
        metaDescription
        ogTitle
        ogDescription
        ogImage @include(if: $withPageSeoSettingsOgImage) {
          id
          assetId
          publicId
          url
          resourceType
          format
          width
          height
          caption
          title
          description
        }
      }
      contentBlockAssignments @include(if: $withPageContentBlockAssignments) {
        id
        type
        block @include(if: $withPageContentBlockAssignmentsBlock) {
          __typename
          ... on CmsTextBlock {
            id
            text

          }
          ... on CmsTextWithImageBlock {
            id
            title
            subtitle
            text
            imagePosition
            imageFixedAspectRatio

          }
          ... on CmsPageHeaderBlock {
            id
            title
            text

          }
          ... on CmsWysiwygBlock {
            id
            html

          }
          ... on CmsHeadingBlock {
            id
            importance
            heading
            addon
            decoration

          }
          ... on CmsTextWithIconBlock {
            id
            title
            text
            imagePosition

          }
          ... on CmsAccordionBlock {
            id

          }
          ... on CmsGridBlock {
            id

          }
          ... on CmsImageBlock {
            id
            text
            fluid

          }
          ... on CmsEmployeesBlock {
            id

          }
          ... on CmsContactBannerBlock {
            id
            email
            phonePrefix
            phone
            phone2Prefix
            phone2

          }
          ... on CmsNewsletterRegisterBlock {
            id
            fluid

          }
          ... on CmsIssuuCatalogBlock {
            id
            publicationCode
            accountName

          }
          ... on CmsFormBlock {
            id
            formName

          }
          ... on CmsHeaderSliderBlock {
            id

          }
          ... on CmsBestsellerSliderBlock {
            id
            fluid

          }
          ... on CmsFilterLeadBlock {
            id
            layout

          }
          ... on CmsTravelTypesBlock {
            id
            layout

          }
          ... on CmsPrefilteredTravelsBlock {
            id
            maxResults

          }
          ... on CmsDividerBlock {
            id
            fluid

          }
          ... on CmsTravelSelectionBlock {
            id

          }
          ... on CmsIframeBlock {
            id
            url
            minHeight

          }
          ... on CmsSliderBlock {
            id
            fluid
            size
            showDots
            showArrows
            showLightbox
            autoplay

          }
          ... on CmsDestinationsBlock {
            id

          }
          ... on CmsTravelGuidesBlock {
            id

          }
          ... on CmsBusfinderBlock {
            id
            title

          }
          ... on CmsBackgroundBlock {
            id
            backgroundVariant

          }
          ... on CmsButtonBlock {
            id
            variant
            size
            position

          }
        }
      }
    }
    travel @include(if: $withTravel) {
      id
      name
      isBestseller
      startDate
      endDate
      availabilityStatus @include(if: $withTravelAvailabilityStatus) {
        id
        label
        status
        isDefaultStatus
        isDefaultWaitlistFallback
        tenantSettings @include(if: $withTravelAvailabilityStatusTenantSettings) {
          id
          label
          info
          switchToStatusInfo
          submitButtonLabel
        }
      }
      executionStatus
      travelConsultant @include(if: $withTravelTravelConsultant) {
        id
        firstName
        lastName
        jobTitle
        description
        email
        image @include(if: $withTravelTravelConsultantImage) {
          id
          assetId
          publicId
          url
          resourceType
          format
          width
          height
          caption
          title
          description
        }
        phone
      }
      label @include(if: $withTravelLabel) {
        id
        label
      }
      title
      description
      introVideoUrl
      includedServices
      excludedServices
      pricingTable
      priceCalculationInfo
      seoSettings @include(if: $withTravelSeoSettings) {
        id
        urlSlug
        metaTitle
        metaDescription
        ogTitle
        ogDescription
        ogImage @include(if: $withTravelSeoSettingsOgImage) {
          id
          assetId
          publicId
          url
          resourceType
          format
          width
          height
          caption
          title
          description
        }
      }
      tenantSettings @include(if: $withTravelTenantSettings) {
        id
        tenant @include(if: $withTravelTenantSettingsTenant) {
          id
          name
          slug
          domain
          externalReference
        }
        onlineStatus
        redirectToBooking
        useTiming
        startDate
        endDate
        travelTypes @include(if: $withTravelTenantSettingsTravelTypes) {
          id
          name
          description
        }
      }
      highlights @include(if: $withTravelHighlights) {
        id
        text
      }
      partners @include(if: $withTravelPartners) {
        id
        name
        url
        logo @include(if: $withTravelPartnersLogo) {
          id
          assetId
          publicId
          url
          resourceType
          format
          width
          height
          caption
          title
          description
        }
        logoWidth
        gtcPdf @include(if: $withTravelPartnersGtcPdf) {
          id
          assetId
          publicId
          url
          resourceType
          format
          width
          height
          caption
          title
          description
        }
      }
      travelGuides @include(if: $withTravelTravelGuides) {
        id
        firstName
        lastName
        description
        image @include(if: $withTravelTravelGuidesImage) {
          id
          assetId
          publicId
          url
          resourceType
          format
          width
          height
          caption
          title
          description
        }
      }
      teams @include(if: $withTravelTeams) {
        id
        name
        members @include(if: $withTravelTeamsMembers) {
          id
          firstName
          lastName
          description
        }
      }
      accommodationAssignments @include(if: $withTravelAccommodationAssignments) {
        id
        accommodation @include(if: $withTravelAccommodationAssignmentsAccommodation) {
          id
          label
          name
          stars
          description
        }
        roomTypes @include(if: $withTravelAccommodationAssignmentsRoomTypes) {
          id
          name
          description
        }
        useCustomRoomTypeSelection
        displayDetails
      }
      accommodations @include(if: $withTravelAccommodations) {
        id
        label
        name
        stars
        description
        roomTypes @include(if: $withTravelAccommodationsRoomTypes) {
          id
          name
          description
        }
        availableAddons @include(if: $withTravelAccommodationsAvailableAddons) {
          id
          name
          description
        }
        gallery @include(if: $withTravelAccommodationsGallery) {
          id
        }
      }
      destinations @include(if: $withTravelDestinations) {
        id
        name
        entryRequirements
        medicalInformation
        language
        timeShift
        climate
        currency
      }
      testimonials @include(if: $withTravelTestimonials) {
        id
        contentBlock @include(if: $withTravelTestimonialsContentBlock) {
          id
          title
          text
          imagePosition
        }
      }
      mainImage @include(if: $withTravelMainImage) {
        id
        assetId
        publicId
        url
        resourceType
        format
        width
        height
        caption
        title
        description
      }
      mainVideo @include(if: $withTravelMainVideo) {
        id
        assetId
        publicId
        url
        resourceType
        format
        width
        height
        caption
        title
        description
      }
      gallery @include(if: $withTravelGallery) {
        id
        images @include(if: $withTravelGalleryImages) {
          id
          assetId
          publicId
          url
          resourceType
          format
          width
          height
          caption
          title
          description
        }
      }
      travelPdf @include(if: $withTravelTravelPdf) {
        id
        assetId
        publicId
        url
        resourceType
        format
        width
        height
        caption
        title
        description
      }
      travelExtensions @include(if: $withTravelTravelExtensions) {
        id
        duration
        name
        description
        highlights @include(if: $withTravelTravelExtensionsHighlights) {
          id
          text
        }
        image @include(if: $withTravelTravelExtensionsImage) {
          id
          assetId
          publicId
          url
          resourceType
          format
          width
          height
          caption
          title
          description
        }
      }
      programType
      itinerary @include(if: $withTravelItinerary) {
        id
        items @include(if: $withTravelItineraryItems) {
          id
          duration
          title
          text
        }
      }
      programText
      pricing @include(if: $withTravelPricing) {
        id
        ageGroupSettings @include(if: $withTravelPricingAgeGroupSettings) {
          id
          freeUntilAge
        }
        isTravelDocumentationAvailable
        customDataConfig @include(if: $withTravelPricingCustomDataConfig) {
          id
          useTravellerForm
          useBookingForm
        }
        travels @include(if: $withTravelPricingTravels) {
          id
          catalogCode
          travelCode
          destination
          name
          transportType
          transportTypeLabel
          importDateTime
          importStatus
          suppressBusBoardingSelection
        }
        webhookConfig @include(if: $withTravelPricingWebhookConfig) {
          id
          enabled
          url
        }
        branding @include(if: $withTravelPricingBranding) {
          id
          logoWidth
        }
        bargainSettings @include(if: $withTravelPricingBargainSettings) {
          id
          active
          untilDaysBeforeStart
        }
        esimSettings @include(if: $withTravelPricingEsimSettings) {
          id
          enabled
        }
        passportConfig @include(if: $withTravelPricingPassportConfig) {
          id
          passportOnly
        }
        tourOperator @include(if: $withTravelPricingTourOperator) {
          id
          name
          url
          logoWidth
        }
        currencyOverride @include(if: $withTravelPricingCurrencyOverride) {
          id
          enabled
          exchangeRate
        }
      }
      minPrice
      minPriceManualOverride
      currency
      faqs @include(if: $withTravelFaqs) {
        id
        question
        answer
      }
    }
  }
}`

// language=GraphQL
export const CREATE_LINK_MUTATION = `
  mutation Mutation($input: CreateLinkInput, $withPage: Boolean = false, $withPageSeoSettings: Boolean = false, $withPageSeoSettingsOgImage: Boolean = false, $withPageContentBlockAssignments: Boolean = false, $withPageContentBlockAssignmentsBlock: Boolean = false, $withTravel: Boolean = false, $withTravelAvailabilityStatus: Boolean = false, $withTravelAvailabilityStatusTenantSettings: Boolean = false, $withTravelTravelConsultant: Boolean = false, $withTravelTravelConsultantImage: Boolean = false, $withTravelLabel: Boolean = false, $withTravelSeoSettings: Boolean = false, $withTravelSeoSettingsOgImage: Boolean = false, $withTravelTenantSettings: Boolean = false, $withTravelTenantSettingsTenant: Boolean = false, $withTravelTenantSettingsTravelTypes: Boolean = false, $withTravelHighlights: Boolean = false, $withTravelPartners: Boolean = false, $withTravelPartnersLogo: Boolean = false, $withTravelPartnersGtcPdf: Boolean = false, $withTravelTravelGuides: Boolean = false, $withTravelTravelGuidesImage: Boolean = false, $withTravelTeams: Boolean = false, $withTravelTeamsMembers: Boolean = false, $withTravelAccommodationAssignments: Boolean = false, $withTravelAccommodationAssignmentsAccommodation: Boolean = false, $withTravelAccommodationAssignmentsRoomTypes: Boolean = false, $withTravelAccommodations: Boolean = false, $withTravelAccommodationsRoomTypes: Boolean = false, $withTravelAccommodationsAvailableAddons: Boolean = false, $withTravelAccommodationsGallery: Boolean = false, $withTravelDestinations: Boolean = false, $withTravelTestimonials: Boolean = false, $withTravelTestimonialsContentBlock: Boolean = false, $withTravelMainImage: Boolean = false, $withTravelMainVideo: Boolean = false, $withTravelGallery: Boolean = false, $withTravelGalleryImages: Boolean = false, $withTravelTravelPdf: Boolean = false, $withTravelTravelExtensions: Boolean = false, $withTravelTravelExtensionsHighlights: Boolean = false, $withTravelTravelExtensionsImage: Boolean = false, $withTravelItinerary: Boolean = false, $withTravelItineraryItems: Boolean = false, $withTravelPricing: Boolean = false, $withTravelPricingAgeGroupSettings: Boolean = false, $withTravelPricingCustomDataConfig: Boolean = false, $withTravelPricingTravels: Boolean = false, $withTravelPricingWebhookConfig: Boolean = false, $withTravelPricingBranding: Boolean = false, $withTravelPricingBargainSettings: Boolean = false, $withTravelPricingEsimSettings: Boolean = false, $withTravelPricingPassportConfig: Boolean = false, $withTravelPricingTourOperator: Boolean = false, $withTravelPricingCurrencyOverride: Boolean = false, $withTravelFaqs: Boolean = false) {
    link: createLink(input: $input) {
      id
      label
      targetBlank
      type
      url
      page @include(if: $withPage) {
        id
        name
        onlineStatus
        seoSettings @include(if: $withPageSeoSettings) {
          id
          urlSlug
          metaTitle
          metaDescription
          ogTitle
          ogDescription
          ogImage @include(if: $withPageSeoSettingsOgImage) {
            id
            assetId
            publicId
            url
            resourceType
            format
            width
            height
            caption
            title
            description
          }
        }
        contentBlockAssignments @include(if: $withPageContentBlockAssignments) {
          id
          type
          block @include(if: $withPageContentBlockAssignmentsBlock) {
            __typename
            ... on CmsTextBlock {
              id
              text

            }
            ... on CmsTextWithImageBlock {
              id
              title
              subtitle
              text
              imagePosition
              imageFixedAspectRatio

            }
            ... on CmsPageHeaderBlock {
              id
              title
              text

            }
            ... on CmsWysiwygBlock {
              id
              html

            }
            ... on CmsHeadingBlock {
              id
              importance
              heading
              addon
              decoration

            }
            ... on CmsTextWithIconBlock {
              id
              title
              text
              imagePosition

            }
            ... on CmsAccordionBlock {
              id

            }
            ... on CmsGridBlock {
              id

            }
            ... on CmsImageBlock {
              id
              text
              fluid

            }
            ... on CmsEmployeesBlock {
              id

            }
            ... on CmsContactBannerBlock {
              id
              email
              phonePrefix
              phone
              phone2Prefix
              phone2

            }
            ... on CmsNewsletterRegisterBlock {
              id
              fluid

            }
            ... on CmsIssuuCatalogBlock {
              id
              publicationCode
              accountName

            }
            ... on CmsFormBlock {
              id
              formName

            }
            ... on CmsHeaderSliderBlock {
              id

            }
            ... on CmsBestsellerSliderBlock {
              id
              fluid

            }
            ... on CmsFilterLeadBlock {
              id
              layout

            }
            ... on CmsTravelTypesBlock {
              id
              layout

            }
            ... on CmsPrefilteredTravelsBlock {
              id
              maxResults

            }
            ... on CmsDividerBlock {
              id
              fluid

            }
            ... on CmsTravelSelectionBlock {
              id

            }
            ... on CmsIframeBlock {
              id
              url
              minHeight

            }
            ... on CmsSliderBlock {
              id
              fluid
              size
              showDots
              showArrows
              showLightbox
              autoplay

            }
            ... on CmsDestinationsBlock {
              id

            }
            ... on CmsTravelGuidesBlock {
              id

            }
            ... on CmsBusfinderBlock {
              id
              title

            }
            ... on CmsBackgroundBlock {
              id
              backgroundVariant

            }
            ... on CmsButtonBlock {
              id
              variant
              size
              position

            }
          }
        }
      }
      travel @include(if: $withTravel) {
        id
        name
        isBestseller
        startDate
        endDate
        availabilityStatus @include(if: $withTravelAvailabilityStatus) {
          id
          label
          status
          isDefaultStatus
          isDefaultWaitlistFallback
          tenantSettings @include(if: $withTravelAvailabilityStatusTenantSettings) {
            id
            label
            info
            switchToStatusInfo
            submitButtonLabel
          }
        }
        executionStatus
        travelConsultant @include(if: $withTravelTravelConsultant) {
          id
          firstName
          lastName
          jobTitle
          description
          email
          image @include(if: $withTravelTravelConsultantImage) {
            id
            assetId
            publicId
            url
            resourceType
            format
            width
            height
            caption
            title
            description
          }
          phone
        }
        label @include(if: $withTravelLabel) {
          id
          label
        }
        title
        description
        introVideoUrl
        includedServices
        excludedServices
        pricingTable
        priceCalculationInfo
        seoSettings @include(if: $withTravelSeoSettings) {
          id
          urlSlug
          metaTitle
          metaDescription
          ogTitle
          ogDescription
          ogImage @include(if: $withTravelSeoSettingsOgImage) {
            id
            assetId
            publicId
            url
            resourceType
            format
            width
            height
            caption
            title
            description
          }
        }
        tenantSettings @include(if: $withTravelTenantSettings) {
          id
          tenant @include(if: $withTravelTenantSettingsTenant) {
            id
            name
            slug
            domain
            externalReference
          }
          onlineStatus
          redirectToBooking
          useTiming
          startDate
          endDate
          travelTypes @include(if: $withTravelTenantSettingsTravelTypes) {
            id
            name
            description
          }
        }
        highlights @include(if: $withTravelHighlights) {
          id
          text
        }
        partners @include(if: $withTravelPartners) {
          id
          name
          url
          logo @include(if: $withTravelPartnersLogo) {
            id
            assetId
            publicId
            url
            resourceType
            format
            width
            height
            caption
            title
            description
          }
          logoWidth
          gtcPdf @include(if: $withTravelPartnersGtcPdf) {
            id
            assetId
            publicId
            url
            resourceType
            format
            width
            height
            caption
            title
            description
          }
        }
        travelGuides @include(if: $withTravelTravelGuides) {
          id
          firstName
          lastName
          description
          image @include(if: $withTravelTravelGuidesImage) {
            id
            assetId
            publicId
            url
            resourceType
            format
            width
            height
            caption
            title
            description
          }
        }
        teams @include(if: $withTravelTeams) {
          id
          name
          members @include(if: $withTravelTeamsMembers) {
            id
            firstName
            lastName
            description
          }
        }
        accommodationAssignments @include(if: $withTravelAccommodationAssignments) {
          id
          accommodation @include(if: $withTravelAccommodationAssignmentsAccommodation) {
            id
            label
            name
            stars
            description
          }
          roomTypes @include(if: $withTravelAccommodationAssignmentsRoomTypes) {
            id
            name
            description
          }
          useCustomRoomTypeSelection
          displayDetails
        }
        accommodations @include(if: $withTravelAccommodations) {
          id
          label
          name
          stars
          description
          roomTypes @include(if: $withTravelAccommodationsRoomTypes) {
            id
            name
            description
          }
          availableAddons @include(if: $withTravelAccommodationsAvailableAddons) {
            id
            name
            description
          }
          gallery @include(if: $withTravelAccommodationsGallery) {
            id
          }
        }
        destinations @include(if: $withTravelDestinations) {
          id
          name
          entryRequirements
          medicalInformation
          language
          timeShift
          climate
          currency
        }
        testimonials @include(if: $withTravelTestimonials) {
          id
          contentBlock @include(if: $withTravelTestimonialsContentBlock) {
            id
            title
            text
            imagePosition
          }
        }
        mainImage @include(if: $withTravelMainImage) {
          id
          assetId
          publicId
          url
          resourceType
          format
          width
          height
          caption
          title
          description
        }
        mainVideo @include(if: $withTravelMainVideo) {
          id
          assetId
          publicId
          url
          resourceType
          format
          width
          height
          caption
          title
          description
        }
        gallery @include(if: $withTravelGallery) {
          id
          images @include(if: $withTravelGalleryImages) {
            id
            assetId
            publicId
            url
            resourceType
            format
            width
            height
            caption
            title
            description
          }
        }
        travelPdf @include(if: $withTravelTravelPdf) {
          id
          assetId
          publicId
          url
          resourceType
          format
          width
          height
          caption
          title
          description
        }
        travelExtensions @include(if: $withTravelTravelExtensions) {
          id
          duration
          name
          description
          highlights @include(if: $withTravelTravelExtensionsHighlights) {
            id
            text
          }
          image @include(if: $withTravelTravelExtensionsImage) {
            id
            assetId
            publicId
            url
            resourceType
            format
            width
            height
            caption
            title
            description
          }
        }
        programType
        itinerary @include(if: $withTravelItinerary) {
          id
          items @include(if: $withTravelItineraryItems) {
            id
            duration
            title
            text
          }
        }
        programText
        pricing @include(if: $withTravelPricing) {
          id
          ageGroupSettings @include(if: $withTravelPricingAgeGroupSettings) {
            id
            freeUntilAge
          }
          isTravelDocumentationAvailable
          customDataConfig @include(if: $withTravelPricingCustomDataConfig) {
            id
            useTravellerForm
            useBookingForm
          }
          travels @include(if: $withTravelPricingTravels) {
            id
            catalogCode
            travelCode
            destination
            name
            transportType
            transportTypeLabel
            importDateTime
            importStatus
            suppressBusBoardingSelection
          }
          webhookConfig @include(if: $withTravelPricingWebhookConfig) {
            id
            enabled
            url
          }
          branding @include(if: $withTravelPricingBranding) {
            id
            logoWidth
          }
          bargainSettings @include(if: $withTravelPricingBargainSettings) {
            id
            active
            untilDaysBeforeStart
          }
          esimSettings @include(if: $withTravelPricingEsimSettings) {
            id
            enabled
          }
          passportConfig @include(if: $withTravelPricingPassportConfig) {
            id
            passportOnly
          }
          tourOperator @include(if: $withTravelPricingTourOperator) {
            id
            name
            url
            logoWidth
          }
          currencyOverride @include(if: $withTravelPricingCurrencyOverride) {
            id
            enabled
            exchangeRate
          }
        }
        minPrice
        minPriceManualOverride
        currency
        faqs @include(if: $withTravelFaqs) {
          id
          question
          answer
        }
      }
    }
  }`

// language=GraphQL
export const UPDATE_LINK_MUTATION = `
  mutation Mutation($input: UpdateLinkInput, $withPage: Boolean = false, $withPageSeoSettings: Boolean = false, $withPageSeoSettingsOgImage: Boolean = false, $withPageContentBlockAssignments: Boolean = false, $withPageContentBlockAssignmentsBlock: Boolean = false, $withTravel: Boolean = false, $withTravelAvailabilityStatus: Boolean = false, $withTravelAvailabilityStatusTenantSettings: Boolean = false, $withTravelTravelConsultant: Boolean = false, $withTravelTravelConsultantImage: Boolean = false, $withTravelLabel: Boolean = false, $withTravelSeoSettings: Boolean = false, $withTravelSeoSettingsOgImage: Boolean = false, $withTravelTenantSettings: Boolean = false, $withTravelTenantSettingsTenant: Boolean = false, $withTravelTenantSettingsTravelTypes: Boolean = false, $withTravelHighlights: Boolean = false, $withTravelPartners: Boolean = false, $withTravelPartnersLogo: Boolean = false, $withTravelPartnersGtcPdf: Boolean = false, $withTravelTravelGuides: Boolean = false, $withTravelTravelGuidesImage: Boolean = false, $withTravelTeams: Boolean = false, $withTravelTeamsMembers: Boolean = false, $withTravelAccommodationAssignments: Boolean = false, $withTravelAccommodationAssignmentsAccommodation: Boolean = false, $withTravelAccommodationAssignmentsRoomTypes: Boolean = false, $withTravelAccommodations: Boolean = false, $withTravelAccommodationsRoomTypes: Boolean = false, $withTravelAccommodationsAvailableAddons: Boolean = false, $withTravelAccommodationsGallery: Boolean = false, $withTravelDestinations: Boolean = false, $withTravelTestimonials: Boolean = false, $withTravelTestimonialsContentBlock: Boolean = false, $withTravelMainImage: Boolean = false, $withTravelMainVideo: Boolean = false, $withTravelGallery: Boolean = false, $withTravelGalleryImages: Boolean = false, $withTravelTravelPdf: Boolean = false, $withTravelTravelExtensions: Boolean = false, $withTravelTravelExtensionsHighlights: Boolean = false, $withTravelTravelExtensionsImage: Boolean = false, $withTravelItinerary: Boolean = false, $withTravelItineraryItems: Boolean = false, $withTravelPricing: Boolean = false, $withTravelPricingAgeGroupSettings: Boolean = false, $withTravelPricingCustomDataConfig: Boolean = false, $withTravelPricingTravels: Boolean = false, $withTravelPricingWebhookConfig: Boolean = false, $withTravelPricingBranding: Boolean = false, $withTravelPricingBargainSettings: Boolean = false, $withTravelPricingEsimSettings: Boolean = false, $withTravelPricingPassportConfig: Boolean = false, $withTravelPricingTourOperator: Boolean = false, $withTravelPricingCurrencyOverride: Boolean = false, $withTravelFaqs: Boolean = false) {
    link: updateLink(input: $input) {
      id
      label
      targetBlank
      type
      url
      page @include(if: $withPage) {
        id
        name
        onlineStatus
        seoSettings @include(if: $withPageSeoSettings) {
          id
          urlSlug
          metaTitle
          metaDescription
          ogTitle
          ogDescription
          ogImage @include(if: $withPageSeoSettingsOgImage) {
            id
            assetId
            publicId
            url
            resourceType
            format
            width
            height
            caption
            title
            description
          }
        }
        contentBlockAssignments @include(if: $withPageContentBlockAssignments) {
          id
          type
          block @include(if: $withPageContentBlockAssignmentsBlock) {
            __typename
            ... on CmsTextBlock {
              id
              text

            }
            ... on CmsTextWithImageBlock {
              id
              title
              subtitle
              text
              imagePosition
              imageFixedAspectRatio

            }
            ... on CmsPageHeaderBlock {
              id
              title
              text

            }
            ... on CmsWysiwygBlock {
              id
              html

            }
            ... on CmsHeadingBlock {
              id
              importance
              heading
              addon
              decoration

            }
            ... on CmsTextWithIconBlock {
              id
              title
              text
              imagePosition

            }
            ... on CmsAccordionBlock {
              id

            }
            ... on CmsGridBlock {
              id

            }
            ... on CmsImageBlock {
              id
              text
              fluid

            }
            ... on CmsEmployeesBlock {
              id

            }
            ... on CmsContactBannerBlock {
              id
              email
              phonePrefix
              phone
              phone2Prefix
              phone2

            }
            ... on CmsNewsletterRegisterBlock {
              id
              fluid

            }
            ... on CmsIssuuCatalogBlock {
              id
              publicationCode
              accountName

            }
            ... on CmsFormBlock {
              id
              formName

            }
            ... on CmsHeaderSliderBlock {
              id

            }
            ... on CmsBestsellerSliderBlock {
              id
              fluid

            }
            ... on CmsFilterLeadBlock {
              id
              layout

            }
            ... on CmsTravelTypesBlock {
              id
              layout

            }
            ... on CmsPrefilteredTravelsBlock {
              id
              maxResults

            }
            ... on CmsDividerBlock {
              id
              fluid

            }
            ... on CmsTravelSelectionBlock {
              id

            }
            ... on CmsIframeBlock {
              id
              url
              minHeight

            }
            ... on CmsSliderBlock {
              id
              fluid
              size
              showDots
              showArrows
              showLightbox
              autoplay

            }
            ... on CmsDestinationsBlock {
              id

            }
            ... on CmsTravelGuidesBlock {
              id

            }
            ... on CmsBusfinderBlock {
              id
              title

            }
            ... on CmsBackgroundBlock {
              id
              backgroundVariant

            }
            ... on CmsButtonBlock {
              id
              variant
              size
              position

            }
          }
        }
      }
      travel @include(if: $withTravel) {
        id
        name
        isBestseller
        startDate
        endDate
        availabilityStatus @include(if: $withTravelAvailabilityStatus) {
          id
          label
          status
          isDefaultStatus
          isDefaultWaitlistFallback
          tenantSettings @include(if: $withTravelAvailabilityStatusTenantSettings) {
            id
            label
            info
            switchToStatusInfo
            submitButtonLabel
          }
        }
        executionStatus
        travelConsultant @include(if: $withTravelTravelConsultant) {
          id
          firstName
          lastName
          jobTitle
          description
          email
          image @include(if: $withTravelTravelConsultantImage) {
            id
            assetId
            publicId
            url
            resourceType
            format
            width
            height
            caption
            title
            description
          }
          phone
        }
        label @include(if: $withTravelLabel) {
          id
          label
        }
        title
        description
        introVideoUrl
        includedServices
        excludedServices
        pricingTable
        priceCalculationInfo
        seoSettings @include(if: $withTravelSeoSettings) {
          id
          urlSlug
          metaTitle
          metaDescription
          ogTitle
          ogDescription
          ogImage @include(if: $withTravelSeoSettingsOgImage) {
            id
            assetId
            publicId
            url
            resourceType
            format
            width
            height
            caption
            title
            description
          }
        }
        tenantSettings @include(if: $withTravelTenantSettings) {
          id
          tenant @include(if: $withTravelTenantSettingsTenant) {
            id
            name
            slug
            domain
            externalReference
          }
          onlineStatus
          redirectToBooking
          useTiming
          startDate
          endDate
          travelTypes @include(if: $withTravelTenantSettingsTravelTypes) {
            id
            name
            description
          }
        }
        highlights @include(if: $withTravelHighlights) {
          id
          text
        }
        partners @include(if: $withTravelPartners) {
          id
          name
          url
          logo @include(if: $withTravelPartnersLogo) {
            id
            assetId
            publicId
            url
            resourceType
            format
            width
            height
            caption
            title
            description
          }
          logoWidth
          gtcPdf @include(if: $withTravelPartnersGtcPdf) {
            id
            assetId
            publicId
            url
            resourceType
            format
            width
            height
            caption
            title
            description
          }
        }
        travelGuides @include(if: $withTravelTravelGuides) {
          id
          firstName
          lastName
          description
          image @include(if: $withTravelTravelGuidesImage) {
            id
            assetId
            publicId
            url
            resourceType
            format
            width
            height
            caption
            title
            description
          }
        }
        teams @include(if: $withTravelTeams) {
          id
          name
          members @include(if: $withTravelTeamsMembers) {
            id
            firstName
            lastName
            description
          }
        }
        accommodationAssignments @include(if: $withTravelAccommodationAssignments) {
          id
          accommodation @include(if: $withTravelAccommodationAssignmentsAccommodation) {
            id
            label
            name
            stars
            description
          }
          roomTypes @include(if: $withTravelAccommodationAssignmentsRoomTypes) {
            id
            name
            description
          }
          useCustomRoomTypeSelection
          displayDetails
        }
        accommodations @include(if: $withTravelAccommodations) {
          id
          label
          name
          stars
          description
          roomTypes @include(if: $withTravelAccommodationsRoomTypes) {
            id
            name
            description
          }
          availableAddons @include(if: $withTravelAccommodationsAvailableAddons) {
            id
            name
            description
          }
          gallery @include(if: $withTravelAccommodationsGallery) {
            id
          }
        }
        destinations @include(if: $withTravelDestinations) {
          id
          name
          entryRequirements
          medicalInformation
          language
          timeShift
          climate
          currency
        }
        testimonials @include(if: $withTravelTestimonials) {
          id
          contentBlock @include(if: $withTravelTestimonialsContentBlock) {
            id
            title
            text
            imagePosition
          }
        }
        mainImage @include(if: $withTravelMainImage) {
          id
          assetId
          publicId
          url
          resourceType
          format
          width
          height
          caption
          title
          description
        }
        mainVideo @include(if: $withTravelMainVideo) {
          id
          assetId
          publicId
          url
          resourceType
          format
          width
          height
          caption
          title
          description
        }
        gallery @include(if: $withTravelGallery) {
          id
          images @include(if: $withTravelGalleryImages) {
            id
            assetId
            publicId
            url
            resourceType
            format
            width
            height
            caption
            title
            description
          }
        }
        travelPdf @include(if: $withTravelTravelPdf) {
          id
          assetId
          publicId
          url
          resourceType
          format
          width
          height
          caption
          title
          description
        }
        travelExtensions @include(if: $withTravelTravelExtensions) {
          id
          duration
          name
          description
          highlights @include(if: $withTravelTravelExtensionsHighlights) {
            id
            text
          }
          image @include(if: $withTravelTravelExtensionsImage) {
            id
            assetId
            publicId
            url
            resourceType
            format
            width
            height
            caption
            title
            description
          }
        }
        programType
        itinerary @include(if: $withTravelItinerary) {
          id
          items @include(if: $withTravelItineraryItems) {
            id
            duration
            title
            text
          }
        }
        programText
        pricing @include(if: $withTravelPricing) {
          id
          ageGroupSettings @include(if: $withTravelPricingAgeGroupSettings) {
            id
            freeUntilAge
          }
          isTravelDocumentationAvailable
          customDataConfig @include(if: $withTravelPricingCustomDataConfig) {
            id
            useTravellerForm
            useBookingForm
          }
          travels @include(if: $withTravelPricingTravels) {
            id
            catalogCode
            travelCode
            destination
            name
            transportType
            transportTypeLabel
            importDateTime
            importStatus
            suppressBusBoardingSelection
          }
          webhookConfig @include(if: $withTravelPricingWebhookConfig) {
            id
            enabled
            url
          }
          branding @include(if: $withTravelPricingBranding) {
            id
            logoWidth
          }
          bargainSettings @include(if: $withTravelPricingBargainSettings) {
            id
            active
            untilDaysBeforeStart
          }
          esimSettings @include(if: $withTravelPricingEsimSettings) {
            id
            enabled
          }
          passportConfig @include(if: $withTravelPricingPassportConfig) {
            id
            passportOnly
          }
          tourOperator @include(if: $withTravelPricingTourOperator) {
            id
            name
            url
            logoWidth
          }
          currencyOverride @include(if: $withTravelPricingCurrencyOverride) {
            id
            enabled
            exchangeRate
          }
        }
        minPrice
        minPriceManualOverride
        currency
        faqs @include(if: $withTravelFaqs) {
          id
          question
          answer
        }
      }
    }
  }`

// language=GraphQL
export const DELETE_LINK_MUTATION = `
  mutation Mutation($input: DeleteLinkInput) {
    deleteLink(input: $input) {
      success
    }
  }`

// language=GraphQL
export const FORCE_DELETE_LINK_MUTATION = `
  mutation Mutation($input: DeleteLinkInput) {
    forceDeleteLink(input: $input) {
      success
    }
  }`
// language=GraphQL
export const LINKS_DEPENDENTS_QUERY = `query Query($id: ID!, $withCmsTextWithImageBlocks: Boolean = false, $withCmsHeaderSliderBlockSlides: Boolean = false, $withCmsButtonBlocks: Boolean = false) {
  groupedDependents: linkDependents(id: $id) {
    cmsTextWithImageBlocks @include(if: $withCmsTextWithImageBlocks) {
      id
      title
      subtitle
      text
      imagePosition
      imageFixedAspectRatio
    }
    cmsHeaderSliderBlockSlides @include(if: $withCmsHeaderSliderBlockSlides) {
      id
      title
      text
    }
    cmsButtonBlocks @include(if: $withCmsButtonBlocks) {
      id
      variant
      size
      position
    }
  }
}`
